import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ENewReviewPublished {
  Set = 'NEW_REVIEW/PUBLISHED_ID/SET',
}

export type TNewReviewPublished = ITypedReduxAction<ENewReviewPublished.Set, number | null>;

export type TNewReviewPublishedActions = TNewReviewPublished;

export const setPublishedId: (id: number | null) => TNewReviewPublished = actionGenerator<
  ENewReviewPublished.Set,
  number | null
>(ENewReviewPublished.Set);
